import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import ParticleService from '../ParticleService';
import { formatSubscriptionDate as formatDate } from '../subscriptionPresentation';

export default function FreeYearActivationModal({ device, onHide, onActivated }) {
  const [activating, setActivating] = useState(false);

  const activate = async () => {
    if (activating || !device) return;
    setActivating(true);
    try {
      const result = await ParticleService.activateIncludedFreePeriod(device.deviceId);
      if (result.error) {
        toast.error(result.detail || result.error);
        return;
      }
      toast.success('Your included free year is now active.');
      onHide();
      await onActivated();
    } catch (error) {
      toast.error(error.message || 'Could not activate your free year. Please try again.');
    } finally {
      setActivating(false);
    }
  };

  return (
    <Modal show={device != null} onHide={() => !activating && onHide()} centered>
      <Modal.Header closeButton={!activating}><Modal.Title>Start included free year?</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>This starts the one-time included dashboard-access period for <strong>{device?.displayName || 'this device'}</strong>. It cannot be restarted later.</p>
        {device?.activationWillBeBackdated && <Alert variant="warning">The activation window ended on {formatDate(device.activationDeadlineUtc)}, so the free period will start from that date.</Alert>}
        <dl className="row mb-0">
          <dt className="col-5">Starts</dt><dd className="col-7">{formatDate(device?.proposedActivationStartsAtUtc)}</dd>
          <dt className="col-5">Ends</dt><dd className="col-7">{formatDate(device?.proposedActivationEndsAtUtc)}</dd>
        </dl>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={activating} onClick={onHide}>Not now</Button>
        <Button variant="primary" disabled={activating} onClick={activate}>{activating ? 'Activating…' : 'Start free year'}</Button>
      </Modal.Footer>
    </Modal>
  );
}
